(function () {
  'use strict';

  angular.module('MktzapApp.Controllers')
    .controller('MessagesPortalSettingsController', messagesPortalSettingsController);

  messagesPortalSettingsController.$inject = ['$rootScope', 'CompanyService', 'NotificationService'];

  function messagesPortalSettingsController ($rootScope, CompanyService, NotificationService) {
    $rootScope.getPageLabels('menu.config.messagesPortalSettings');

    var vmMessagesPortalCtrl = this;

    CompanyService
      .loadMetadata()
      .$promise
      .then(function (data) {
        vmMessagesPortalCtrl.metadata = data;
      })
      .catch(function (error) {
        NotificationService.errorHandler(error, $rootScope.labels.errorLoadMeta);
      });

    vmMessagesPortalCtrl.allow = function () {
      CompanyService
        .saveMetadata(vmMessagesPortalCtrl.metadata)
        .$promise
        .then(function (data) {
          vmMessagesPortalCtrl.metadata = data;
          $rootScope.company_metadata = data;
          NotificationService.successHandler(data, $rootScope.labels.saveConfig);
        })
        .catch(function (error) {
          NotificationService.errorHandler(error, $rootScope.labels.errorConfig);
        });
    };
  }
})();
